import * as Yup from 'yup'; 
import { onlyChars, firstLetterCapitalized } from '../../components/form/Helpers/Parsers'
import { isPostalCodeValid } from '../../components/form/Validations/PostalCodeValidation'
import { FieldTypes, IFields, InputModes } from '../../models/form/IFieldsDefinition'
import { FormValidationObject } from '../../models/form/IFormDefinition'


export enum AddressInfoFieldsNames {
   Street = "Street",
   HouseNumber = "HouseNumber",
   ApartamentNumber = "ApartamentNumber",
   PostalCode = "PostalCode",
   City = "City",
}


export const addressInfoFields: IFields = {
   [AddressInfoFieldsNames.Street]: {
      order: 0,
      name: AddressInfoFieldsNames.Street,
      type: FieldTypes.string,
      label: "Ulica",
      maxLength: 50,
      editable: true,
      parser: firstLetterCapitalized,
   },
   [AddressInfoFieldsNames.HouseNumber]: {
      order: 5,
      name: AddressInfoFieldsNames.HouseNumber,
      type:  FieldTypes.string,
      label: "Numer domu",
      maxLength: 7,
      editable: true,
   },
   [AddressInfoFieldsNames.ApartamentNumber]: {
      order: 10,
      name: AddressInfoFieldsNames.ApartamentNumber,
      type:  FieldTypes.string,
      label: "Numer mieszkania",
      maxLength: 7,
      editable: true,
   },
   [AddressInfoFieldsNames.PostalCode]: {
      order: 15,
      name: AddressInfoFieldsNames.PostalCode,
      type:  FieldTypes.string,
      label: "Kod pocztowy",
      mask: "99-999",
      editable: true,
      inputMode: InputModes.numeric,
   },
   [AddressInfoFieldsNames.City]: {
      order: 20,
      name: AddressInfoFieldsNames.City,
      type:  FieldTypes.string,
      label: "Miejscowość",
      maxLength: 50,
      editable: true,
      parser: onlyChars,
   },
}

export const addressInfoFieldValidations: FormValidationObject<typeof AddressInfoFieldsNames> = {
   [AddressInfoFieldsNames.Street]: Yup.string().trim().required('Nieprawidłowa wartość').min(2, 'Nieprawidłowa wartość') as Yup.StringSchema<string>,
   [AddressInfoFieldsNames.HouseNumber]: Yup.string().trim().required('Nieprawidłowa wartość').max(10, 'Nieprawidłowa wartość') as Yup.StringSchema<string>,
   [AddressInfoFieldsNames.ApartamentNumber]: undefined,
   [AddressInfoFieldsNames.PostalCode]:  Yup.string().trim().test(isPostalCodeValid) as Yup.StringSchema<string>,
   [AddressInfoFieldsNames.City]: Yup.string().trim().required("Nieprawidłowa wartość") as Yup.StringSchema<string>,
}